module.exports = __webpack_public_path__ + "img/Picture7.b74be65e.png";